import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';

import MojitoMainSportsbook from 'mojito/applications/sports/main/main-sportsbook.js';

import {ApplicationConfig} from '#core/config/application-config.js';
import {notifyAppIsLoaded} from '#core/application/application-loaded-notifier.js';

import {MaintenanceView} from '#core/application/modules/static-pages/maintenance/maintenance-view.jsx';
import {selectVisualConfigHash} from '#core/application/modules/visual-config-actions.js';

export function MainSportsbook(props) {
    const [showMaintenanceView, setShowMaintenanceView] = useState(false);
    const configHash = useSelector(selectVisualConfigHash);

    useEffect(() => {
        if (!GENBET_BASED) return;
        fetch(new URL('/health/status', ApplicationConfig.apiUrl).toString())
            .then(response => response.json())
            .then(data => {
                const isUp = data.status === 'UP' && (!data.errors || data.errors.length === 0);

                setShowMaintenanceView(!isUp);

                if (isUp) {
                    setTimeout(notifyAppIsLoaded);
                }
            })
            .catch(() => {
                setShowMaintenanceView(false);
            });
    }, []);

    if (showMaintenanceView) {
        return <MaintenanceView />;
    }

    return <MojitoMainSportsbook key={configHash} {...props} />;
}
